import { getSettingValueWithoutAssignment } from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { LOW_ORDER_MINIMUM_THRESHOLD } from "@faire/web-api--source/indigofair/settings/LOW_ORDER_MINIMUM_THRESHOLD";

export const getSettingLowOrderMinimumThreshold = (): IFaireMoney =>
  getSettingValueWithoutAssignment(
    LOW_ORDER_MINIMUM_THRESHOLD,
    IFaireMoney.build({})
  );
